import store from 'store/dist/store.modern';
var TOKEN_KEY = 'relay-auth-provider:token';

var LocalTokenStorage =
/*#__PURE__*/
function () {
  function LocalTokenStorage(key) {
    if (key === void 0) {
      key = TOKEN_KEY;
    }

    this.key = key;
  }

  var _proto = LocalTokenStorage.prototype;

  _proto.load = function load() {
    var tokenResponse = store.get(this.key, null);

    if (!tokenResponse || Date.now() > tokenResponse.expiresAt) {
      this.clear();
      return null;
    }

    return tokenResponse;
  };

  _proto.save = function save(token) {
    store.set(this.key, token);
  };

  _proto.clear = function clear() {
    store.remove(this.key);
  };

  return LocalTokenStorage;
}();

export { LocalTokenStorage as default };